const InputSerialNumber = ({ serialNumber, handleInputSerialNumber, classNameStyle }) => {
    return (
        <input
            id='serial-number-input'
            className={classNameStyle}
            value={serialNumber}
            onChange={handleInputSerialNumber}
        />
    );
};

export default InputSerialNumber;